<template>
    <div class="main">
        <a-row class="container" :gutter="0">
            <a-col :span="24" style="padding-bottom: 10px;" ref="search">
                <a-row>
                    <a-col span="24">
                        <a-form
                                layout="inline"
                                :form="form"
                                @submit="handleSubmit"
                        >
                            <a-form-item label="标题">
                                <a-input
                                        v-decorator="[
                                          'title',
                                          {rules: [{ required: false }]}
                                        ]"
                                        placeholder="请输入关键字"
                                >
                                    <a-icon
                                            slot="prefix"
                                            type="edit"
                                            style="color:rgba(0,0,0,.25)"
                                    />
                                </a-input>
                            </a-form-item>
                            <a-form-item label="时间筛选" style="margin-right: 0px;">
                                <a-date-picker placeholder="开始时间" style="width: 130px;" @change="chooseBeginTime"/>
                            </a-form-item>
                            <span style="width: 20px;height: 32px;line-height: 32px;text-align: center;margin: 0 auto;display: inline-block;">- </span>
                            <a-form-item>
                                <a-date-picker placeholder="截止时间" style="width: 130px;" @change="chooseEndTime"/>
                            </a-form-item>
                            <a-form-item label="紧急任务">
                                <a-select defaultValue="0" style="width: 60px" @change="handleSearchIsUrgent" >
                                    <a-select-option value="0">否</a-select-option>
                                    <a-select-option value="1">是</a-select-option>
                                </a-select>
                            </a-form-item>
                            <a-form-item>
                                <a-button
                                        type="primary"
                                        html-type="submit"
                                        icon="search"
                                >
                                    搜索
                                </a-button>
                            </a-form-item>
                            <a-form-item v-if="!isSelectingTaskAction">
                                <a-button type="primary" @click="addTask">添加</a-button>
                            </a-form-item>
                        </a-form>
                    </a-col>
                </a-row>
            </a-col>
            <a-divider style="margin: 0;margin-bottom: 10px;"/>
            <a-col :span="24">
                <a-spin tip="加载中..." :spinning="spinning">
                    <div
                            class="demo-infinite-container"
                            v-infinite-scroll="handleInfiniteOnLoad"
                            :infinite-scroll-disabled="busy"
                            :infinite-scroll-distance="10"
                            :style="{height: listsHeight + 'px'}"
                    >
                        <a-list :dataSource="articleLists">
                            <a-list-item slot="renderItem" slot-scope="item, index">
                                <a slot="actions" @click.stop="chooseItem(item.id, item.title)" v-if="isSelectingTaskAction" style="font-size: 20px;"><a-icon type="check-square" theme="twoTone" twoToneColor="red" v-if="choosedTaskId === item.id"/><a-icon type="border" v-else style="font-size: 20px;"/></a>
                                <a-popover placement="topLeft">
                                    <template slot="content">
                                        <p>标引：{{item.tagtitle}}</p>
                                        <p>发布人：{{item.adduser}}</p>
                                    </template>
                                    <a-list-item-meta :description="'执行时间：' + item.starttime + '至' + item.endtime" @click="toTaskDetail(item.id)">
                                        <a slot="title">{{item.title}}<a-icon type="fire" style="color: red;margin-left: 6px;" v-show="item.urgent == 1"/></a>
                                        <a-avatar slot="avatar" icon="file-text" style="backgroundColor: #1890ff"/>
                                    </a-list-item-meta>
                                </a-popover>
                                <div class="desc">
                                    <p v-if="item.status == 5"><a-tag color="#2db7f5" style="float: right;">已完成</a-tag><br/></p>
                                    {{item.addtime}}
                                </div>
                                <div style="margin-left: 20px;" @click="deleteTask(item.id, item.title)" v-if="!isSelectingTaskAction"><a-button type="danger" shape="circle" icon="delete" /></div>
                            </a-list-item>
                            <div v-if="loading && !busy" class="demo-loading-container">
                                <a-spin />
                            </div>
                        </a-list>
                    </div>
                </a-spin>
            </a-col>
        </a-row>
        <footer-tool-bar v-show="isSelectingTaskAction">
            <a-button type="primary" @click="goBack">确定选择</a-button>
        </footer-tool-bar>
    </div>
</template>

<script>
    import infiniteScroll from 'vue-infinite-scroll'
    import FooterToolBar from '../../components/FooterToolBar'
    const nums = 20
    export default {
        name: "TaskList",
        components:{
            FooterToolBar
        },
        directives: { infiniteScroll },
        data () {
            return {
                userInfo: '',
                page: 1,
                searchValue: '',
                beginTime: '',
                endTime: '',
                urgent: '',
                articleLists: [],
                loading: false,
                busy: false,
                spinning: true,
                listsHeight: 0,
                choosedTaskId: '',
                choosedTaskName: '',
                currentIndex: 0,
                footerBarHeight: 0,
                isSelectingTaskAction: false,
                form: this.$form.createForm(this),
            }
        },
        methods: {
            chooseItem (id, name) {
                this.currentIndex = parseInt(id)
                this.choosedTaskName = name
                this.choosedTaskId = id
            },
            getList () {
                this.busy = true
                this.$http.post('api/assign/tasklist', { page: this.page, title: this.searchValue, starttime: this.beginTime, endtime: this.endTime, urgent: this.urgent})
                    .then((res) => {
                        this.busy = false
                        this.spinning = false
                        this.loading = false
                        if (res.data.state === 200) {
                            if (res.data.data.length > 0) {
                                var taskLists = res.data.data
                                for (var i in taskLists) {
                                    taskLists[i].starttime = this.$commonFunction.transferTime(new Date(taskLists[i].starttime))
                                    taskLists[i].endtime = this.$commonFunction.transferTime(new Date(taskLists[i].endtime))
                                }
                                this.articleLists.push.apply(this.articleLists, taskLists)
                                if (this.articleLists.length < nums) {
                                    this.busy = true
                                }
                            } else {
                                this.page--
                            }
                        } else {
                            this.page--
                        }
                    })
                    .catch(() => {
                        this.busy = false
                        this.spinning = false
                        this.loading = false
                        this.page--
                    })
            },
            handleInfiniteOnLoad  () {
                this.loading = true
                if (this.articleLists.length < nums) {
                    this.loading = false
                    this.busy = true
                    return
                }
                if (!this.busy) {
                    this.page++
                    this.getList()
                }
            },
            goBack () {
                if (this.choosedTaskId && this.choosedTaskName) {
                    this.$store.commit('storeChoosedTaskInfo', {id: this.choosedTaskId, name: this.choosedTaskName})
                } else { // 排除未选择时 返回不改变全局变量
                }
                this.$router.go(-1)
            },
            addTask () {
                this.$router.push('/Main/Task/AddTask')
            },
            handleSubmit  (e) { // 搜索
                e.preventDefault();
                this.form.validateFields((err, values) => {
                    if (values.title) {
                        this.searchValue = values.title
                    }
                });
                if (!this.spinning) {
                    this.articleLists = []
                    this.loading = false
                    this.busy = false
                    this.spinning = true
                    this.page = 1
                    this.getList()
                }
            },
            handleSearchIsUrgent (value) {
                this.urgent = value
            },
            chooseBeginTime (date, dateString) {
                this.beginTime = dateString
            },
            chooseEndTime (date, dateString) {
                this.endTime = dateString
            },
            deleteTask (id, tasktitle) {
                const that = this
                that.$confirm({
                    title: '确定删除此"' + tasktitle + '"任务?',
                    okText: '确定',
                    okType: 'danger',
                    cancelText: '取消',
                    onOk() {
                        that.$http.post('api/assign/taskdel', { ids: id})
                            .then((res) => {
                                if (res.data.state === 200) {
                                    that.$commonFunction.removeElementInArray(id, that.articleLists)
                                    that.$message.success('已删除')
                                }
                            })
                            .catch(() => {
                            })
                    },
                    onCancel() {
                    },
                });
            },
            toTaskDetail (id) {
                this.$router.push({path: '/Main/Task/TaskDetail', query: {id: id}})
            }
        },
        created() {
            this.userInfo = JSON.parse(localStorage.getItem('siteinfo'))
        },
        mounted() {
            this.isSelectingTaskAction = this.$store.state.isSelectingTaskAction
            if (this.isSelectingTaskAction) {
                this.footerBarHeight = 56
            }
            this.listsHeight = window.innerHeight - 92 - 40 - this.footerBarHeight - this.$refs.search.$el.clientHeight - 11// 92为顶部导航高度 地址栏高度、 40 margin距离、footerBarHeight 56 底部悬浮按钮高度 11 分割线高度
            this.getList()
        },
        beforeRouteEnter (to, from, next) {
            next(vm => {
            })
        },
        beforeRouteLeave (to, from, next) {
            if (from.path.indexOf('TaskList') > -1 && to.path.indexOf('AddArticle') > -1) {
                this.$store.commit('storeIsSelectingTaskAction', false)
            }
            next()
        }
    }
</script>

<style scoped>
    .main {
        position: absolute;
        top: 42px;
        right: 0;
        bottom: 0;
        left: 0;
        overflow-y: auto;
        overflow-x: hidden;
        background-color: #fff;
        padding-left:10px;
    }
    .container{
        margin-top: 20px;
        margin-bottom: 20px;
        padding-left: 10px;
        padding-right: 20px;
    }
    .demo-infinite-container {
        border: 1px solid #e8e8e8;
        border-radius: 4px;
        overflow: auto;
        padding: 0px 24px;
        overflow-x: hidden;
    }
    .demo-loading-container {
        position: absolute;
        bottom: 40px;
        width: 100%;
        text-align: center;
    }
    .desc{
        line-height: 22px;
    }
    .desc >>> p{
        margin-bottom: 8px;
    }
    .ant-list-item-meta{
        cursor: pointer;
    }
</style>
